import { SchedulerDateNavigationSection } from '@lp/features/Scheduler/components';
import { WorkdaySyncData } from '@lp/features/Scheduler/types';
import { CCResourcesWithShifts } from '@/api/apis/resources/schedule';
import { CCSchedulerFiltersSection } from './components';

type CCSchedulerControlRowProps = {
  readonly?: boolean;
  selectedDate: Date;
  shiftsData: CCResourcesWithShifts;
  workdayData?: WorkdaySyncData;
  onDateChange: (date: Date) => void;
};

export const CCSchedulerControlRow = ({
  readonly,
  selectedDate,
  shiftsData,
  workdayData,
  onDateChange,
}: CCSchedulerControlRowProps) => {
  return (
    <div className="flex items-center gap-2 justify-between grow">
      <SchedulerDateNavigationSection selectedDate={selectedDate} onDateChange={onDateChange} />
      <CCSchedulerFiltersSection shiftsData={shiftsData} workdayData={workdayData} readonly={readonly} />
    </div>
  );
};
